<template>
	<div class="eia-form-group"
		:class="classes">
		<slot></slot>

		<eia-label
			:required="required"
			@click="click"
			:for="id">
			<slot name="label"></slot>
		</eia-label>
	</div>
</template>

<script>
export default {
	name: 'eia-form-group',
	props: {
		id: {
			type: String,
			required: true,
		},

		required: {
			type: Boolean,
			default: false,
		},

		variation: {
			type: String,
			default: 'inline',
			validator( value ) {
				return value.match( /inline|stacked/ );
			},
		},

		onLabelClick: {
			type: Function,
			required: false,
		},
	},

	computed: {
		classes() {
			return `eia-form-group--${this.variation}`;
		},
	},

	methods: {
		click(){
			if( this.onLabelClick ){
				return this.onLabelClick();
			}
		},
	},
};
</script>

<style lang="scss">
.eia-form-group {
	margin: 12px 0;
	display: flex;
	align-items: center;
	justify-content: flex-start;

	&--inline {
		flex-direction: row;

		.eia-label {
			margin-left: 8px;
		}
	}

	&--stacked {
		align-items: flex-start;
		flex-direction: column-reverse;

		.eia-label {
			margin-bottom: 8px;
		}

		.eia-validated-input {
			margin: 0;
		}
	}
}
</style>
